<script lang="ts">
	import Megaphone from '@lucide/svelte/icons/megaphone'
	import StarPlus from '@lucide/svelte/icons/star-plus'
	import { Image } from '@unpic/svelte'
	import { cn } from 'tailwind-variants'

	import { page } from '$app/state'
	import { Button, type ButtonSize } from '#lib/components/ui/button/index.js'
	import { m } from '#lib/paraglide/messages.js'
	import { phg, hashToOption } from '#lib/utils/posthog.js'

	const option = $derived(hashToOption(page.data.user, 3))

	let {
		class: className,
		size,
	}: {
		class?: string
		size?: ButtonSize
	} = $props()
</script>

{#if option === 1}
	<Button
		class={className}
		href="https://tally.so/r/44qM7k"
		rel="external noopener noreferrer"
		{size}
		target="_blank"
		variant="glowing"
	>
		<Megaphone />

		Advertise on Chainspect
	</Button>
{:else if option === 2}
	<Button
		class={className}
		href="https://tally.so/r/n058X6"
		rel="external noopener noreferrer"
		{size}
		target="_blank"
		variant="glowing"
	>
		<StarPlus />

		{m.menu_get_listed_long()}
	</Button>
{:else}
	<a
		class={cn('glowing flex items-center justify-center', className)}
		aria-label="Claim your $20 bonus"
		href="https://www.bybit.com/invite?ref=WGD34YY&medium=referral&utm_campaign=evergreen&share_to=post"
		onclick={() => phg.capture('bybit_banner_click')}
		rel="external noopener noreferrer"
		target="_blank"
	>
		<Image
			class="xs:h-16 h-10 rounded-lg sm:h-20"
			alt="Bybit referral banner"
			crossorigin="anonymous"
			decoding="async"
			fetchpriority="high"
			loading="eager"
			priority
			src="https://res.cloudinary.com/dcruwhddg/image/upload/ads/bybit-banner-150.jpg"
			width={1248}
		/>
	</a>
{/if}
